export default function within({value}, ...allowed) {
    if (!Array.isArray(value)) {
        value = [value];
    }

    value.forEach(v => {
        if (!allowed.includes(v)) {
            return false;
        }
    });

    return true;
}
